import React, { useEffect, useRef, useState } from 'react'
const getWidth = (format, internalValue) => {
    const length = format.length
    let width = 30
    if (length === 2) {
        width = 20
    } else if (length === 3) {
        width = 38
    } else if (length === 4) {
        width = 36
    }

    return width + 'px'
}

class DateInputBase extends React.Component<any, any> {
    node: any
    constructor(props) {
        super(props)

        this.state = {
            internalValue: props.value,
            priorValue: props.value,
            finalValue: props.value,
        }
        this.node = React.createRef()
    }

    componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any) {
        if (prevProps.value !== this.props.value) {
            this.setFinalValue(this.props.value)
        }
    }

    setInternalValue = (internalValue) => {
        this.setState(() => {
            return { internalValue }
        })
    }

    setFinalValue = (finalValue) => {
        this.setState(
            () => {
                return { finalValue, internalValue: finalValue, priorValue: finalValue }
            },
            () => {
                this.props.onChange(finalValue)
            },
        )
    }

    clearInput = () => {
        this.setState({ finalValue: '' })
    }

    handleBlur = (e) => {
        const { internalValue, priorValue } = this.state
        this.props.onBlur(internalValue, this.setFinalValue, this.clearInput, this.zeroPadValue, priorValue)
    }

    zeroPadValue = (_val) => {
        const valLength = _val.length
        const formatLength = this.props.format.length
        const zeroPadDigits = formatLength - valLength
        let val = _val

        if (zeroPadDigits) {
            const padding = new Array(zeroPadDigits + 1).join('0')
            val = padding + val
        }
        return val
    }

    render() {
        const {
            focusNextInput,
            index,
            format,
            value,
            handleInternalChange,
            onChange,
            onBlur,
            placeholder,
            isDisabled,
            displayValue,
        } = this.props

        const { internalValue } = this.state

        const style = {
            width: getWidth(format, internalValue),
        }

        const v = displayValue ? displayValue(internalValue) : internalValue

        return (
            <input
                disabled={isDisabled}
                ref={this.node}
                data-index={index}
                style={style}
                className='r-dateinput-date-el'
                value={v}
                onFocus={(e) => {
                    this.node.current.select()
                }}
                onChange={(e) => {
                    handleInternalChange(this.setInternalValue, this.state.internalValue)(e)
                }}
                onBlur={this.handleBlur}
                // onBlur={(e) => {
                //   onChange(internalValue)
                // }}
                placeholder={placeholder}
            />
        )
    }
}
//
// const DateInputBasex = ({
//     focusNextInput,
//     index,
//     format,
//     value,
//     handleInternalChange,
//     onChange,
//     onBlur,
//     placeholder,
//     isDisabled,
// }) => {
//     const style = {
//         width: getWidth(format),
//     }
//     const node = useRef(null)
//     const [mountComplete, setMountComplete] = useState<boolean>(false)
//     const [priorValue, setPriorValue] = useState<string>(value)
//     const [internalValue, setInternalValue] = useState<string>(value ? value.toString() : '')
//     const [finalVal, setFinalValue] = useState<string>(value)
//     console.log('INTER', internalValue)
//     const handleChange = (value) => {
//         setInternalValue(value)
//         onChange(value)
//     }
//
//     const handleSetFinalValue = (v) => {
//         // if (typeof v === 'string' && v.length > 0) {
//         //     v = parseInt(v)
//         // }
//         setFinalValue(v)
//     }
//
//     const handleBlur = (e) => {
//         onBlur(internalValue, handleSetFinalValue, clearInput, zeroPadValue, priorValue)
//     }
//
//     const clearInput = () => {
//         setInternalValue('')
//         onChange('')
//     }
//     const zeroPadValue = (_val) => {
//         const valLength = _val.length
//         const formatLength = format.length
//         const zeroPadDigits = formatLength - valLength
//         let val = _val
//
//         if (zeroPadDigits) {
//             const padding = new Array(zeroPadDigits + 1).join('0')
//             val = padding + val
//         }
//         return val
//     }
//
//     useEffect(() => {
//         setMountComplete(true)
//     }, [])
//
//     useEffect(() => {
//         if (mountComplete) {
//             setInternalValue(finalVal)
//             setPriorValue(finalVal)
//             handleChange(finalVal)
//         }
//     }, [finalVal])
//
//     useEffect(() => {
//         const v = value
//         if (!isNaN(value)) {
//             setInternalValue(value)
//         }
//     }, [value])
//
//     console.log('VALUE', '********')
//     console.log('VALUE', internalValue)
//     return (
//         <input
//             disabled={isDisabled}
//             ref={node}
//             data-index={index}
//             style={style}
//             type='number'
//             className='r-dateinput-date-els'
//             value={internalValue}
//             onFocus={(e) => {
//                 node.current.select()
//             }}
//             onChange={handleInternalChange(setInternalValue, internalValue)}
//             onBlur={handleBlur}
//             // onBlur={(e) => {
//             //   onChange(internalValue)
//             // }}
//             placeholder={placeholder}
//         />
//     )
// }
export default DateInputBase
